import * as uuid from 'uuid';
import * as BillingTypes from '@/constants/billing-payment-type';

export class CampPricing {
    id;
    name;
    gradeFrom;
    gradeTo;
    timeFrom;
    timeTo;
    price;
    maxEnroll;
    waitList;
    maxWaitList;
    billingType;

    constructor(obj) {
        this.id = obj && obj.id || uuid();
        this.name = obj && obj.name || '';
        this.gradeFrom = obj && obj.gradeFrom || null;
        this.gradeTo = obj && obj.gradeTo || null;
        this.ageFrom = obj && obj.ageFrom || null;
        this.ageTo = obj && obj.ageTo || null;
        this.timeFrom = obj && obj.timeFrom || '9:00';
        this.timeTo = obj && obj.timeTo || '12:00';
        this.price = obj && obj.price || 0;
        this.maxEnroll = obj && obj.maxEnroll || 10;
        this.waitList = obj && obj.waitList || false;
        this.maxWaitList = obj && obj.maxWaitList || 10;
        this.new = obj && obj.id ? false : true;
        this.billingType = obj && obj.billingType || BillingTypes.SESSION;
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/camp-form/camp-pricing.js